import axios from 'axios'
import store from '../store'

let req = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    'Content-Type': 'application/json'
  }
})

req.interceptors.request.use(function(config){
    const token = store.state.token;
    config.headers.Authorization = "Bearer " + token;
    return config;
})

export default req